
module.exports = {
    "colorSet1": [
        {
            "idSet": "8a15f263a4",
            "name": "Rich Black",
            "rgbHex": "000000",
            "cmyk": "cmyk(30.00%,20.00%,0.00%,100.00%)"
        },
        {
            "idSet": "8a15f263a4",
            "name": "White",
            "rgbHex": "ffffff",
            "cmyk": "cmyk(0.00%,0.00%,0.00%,0.00%)"
        }
    ],
    "colorSet2": [
        {
            "idSet": "8a15f263a4",
            "name": "Blue",
            "rgbHex": "00267F",
            "cmyk": "cmyk(100.00%,88.00%,24.00%,20.00%)"
        },
        {
            "idSet": "8a15f263a4",
            "name": "White",
            "rgbHex": "ffffff",
            "cmyk": "cmyk(0.00%,0.00%,0.00%,0.00%)"
        }
    ],
    "colorSet3": [
        {
            "idSet": "8a15f263a4",
            "name": "Cypress",
            "rgbHex": "00523d",
            "cmyk": "cmyk(76.00%,0.00%,60.00%,69.00%)"
        },
        {
            "idSet": "8a15f263a4",
            "name": "White",
            "rgbHex": "ffffff",
            "cmyk": "cmyk(0.00%,0.00%,0.00%,0.00%)"
        }
    ],
    "colorSet4": [
        {
            "idSet": "8a15f263a4",
            "name": "Cimarron",
            "rgbHex": "820024",
            "cmyk": "cmyk(0.00%,100.00%,60.00%,55.00%)"
        },
        {
            "idSet": "8a15f263a4",
            "name": "White",
            "rgbHex": "ffffff",
            "cmyk": "cmyk(0.00%,0.00%,0.00%,0.00%)"
        }
    ]
};

